import film1 from "../assets/series/evolution.jpg";
import film2 from "../assets/series/furies.jpg";
import film3 from "../assets/series/garance.webp";
import film4 from "../assets/series/hexed.jpg";
import film5 from "../assets/series/imperio-del-aguila.jpg";
import film6 from "../assets/series/lioness.jpg";
import film7 from "../assets/series/lor-bleu.jpg";
import film8 from "../assets/series/made-in-france.jpg";
import film9 from "../assets/series/manhunt.webp";
import film10 from "../assets/series/money-heist-s6.jpg";
import film11 from "../assets/series/mortal-kombat-2.webp";
import film12 from "../assets/series/predator-badlands.webp";
import film13 from "../assets/series/reacher-s4.jpg";
import film14 from "../assets/series/santita.jpg";
import film15 from "../assets/series/scarpetta.jpg";
import film16 from "../assets/series/si-es-martes-es-asesinato.jpg";
import film17 from "../assets/series/soleil-noir.jpg";
import film18 from "../assets/series/star-academy.webp";
import film19 from "../assets/series/swapped.jpg";
import film20 from "../assets/series/swiped.webp";
import film21 from "../assets/series/the-gentlemen-serie.webp";
import film22 from "../assets/series/the-odyssey.webp";
import film23 from "../assets/series/thursday-murder-club.webp";
import film24 from "../assets/series/tras-el-verano.webp";
import film25 from "../assets/series/trinity.jpg";
import film26 from "../assets/series/wake-up-dead-man.webp";
import film27 from "../assets/series/zootopia-2.webp";

import chn1 from "../assets/channel/Apple_TV.png";
import chn2 from "../assets/channel/Arte.png";
import chn3 from "../assets/channel/Bein_Sports.png";
import chn4 from "../assets/channel/Canal+.png";
import chn5 from "../assets/channel/DAZN.png";
import chn6 from "../assets/channel/Disney+.png";
import chn7 from "../assets/channel/HBO_Max.png";
import chn8 from "../assets/channel/Hulu.png";
import chn9 from "../assets/channel/M6.png";
import chn10 from "../assets/channel/Netflix.png";
import chn11 from "../assets/channel/OCS.png";
import chn12 from "../assets/channel/Pluto_TV.png";
import chn13 from "../assets/channel/Prime_Video.png";
import chn14 from "../assets/channel/RMC.png";
import chn15 from "../assets/channel/TF1.png";
import chn16 from "../assets/channel/W9.png";
import chn17 from "../assets/channel/TF1_Films.png";
import chn18 from "../assets/channel/MBC_Group.png";

import SectionHeading from '../components/SectionHeading';
import Marquee from '../components/Marquee';
import Reveal from '../components/Reveal';
import { useLanguage } from '../i18n/LanguageContext';
import { filmContent } from '../i18n/content/film';

export default function Film() {
  const { lang } = useLanguage();
  const c = filmContent[lang];
  const films = [
    { image: film1, name: "Evolution" },
    { image: film3, name: "Garance" },
    { image: film4, name: "Hexed" },
    { image: film11, name: "Mortal Kombat 2" },
    { image: film12, name: "Predator: Badlands" },
    { image: film16, name: "Si es Martes, es Asesinato" },
    { image: film17, name: "Soleil Noir" },
    { image: film19, name: "Swapped" },
    { image: film20, name: "Swiped" },
    { image: film22, name: "The Odyssey" },
    { image: film23, name: "Thursday Murder Club" },
    { image: film24, name: "Tras el Verano" },
    { image: film26, name: "Wake Up Dead Man" },
    { image: film27, name: "Zootopia 2" },
  ].map((film, i) => ({ id: i, ...film }));

  const series = [
    { image: film2, name: "Furies" },
    { image: film5, name: "Imperio del Águila" },
    { image: film7, name: "L'Or Bleu" },
    { image: film8, name: "Made in France" },
    { image: film6, name: "Lioness" },
    { image: film9, name: "Manhunt" },
    { image: film10, name: "Money Heist S6" },
    { image: film13, name: "Reacher S4" },
    { image: film14, name: "Santita" },
    { image: film15, name: "Scarpetta" },
    { image: film18, name: "Star Academy" },
    { image: film21, name: "The Gentlemen" },
    { image: film25, name: "Trinity" },
  ].map((show, i) => ({ id: i, ...show }));

  const channels = [
    { id: 1, image: chn5, name: "DAZN" },
    { id: 2, image: chn10, name: "Netflix" },
    { id: 3, image: chn13, name: "Amazon Prime Video" },
    { id: 4, image: chn6, name: "Disney+" },
    { id: 5, image: chn4, name: "CANAL+" },
    { id: 6, image: chn3, name: "beIN SPORTS" },
    { id: 7, image: chn15, name: "TF1" },
    { id: 8, image: chn7, name: "HBO Max" },
    { id: 9, image: chn16, name: "W9" },
    { id: 10, image: chn11, name: "OCS" },
    { id: 11, image: chn12, name: "Pluto TV" },
    { id: 12, image: chn1, name: "Apple TV+" },
    { id: 13, image: chn14, name: "RMC SPORT" },
    { id: 14, image: chn9, name: "M6" },
    { id: 15, image: chn17, name: "TF1 SÉRIES FILMS" },
    { id: 16, image: chn8, name: "Hulu" },
    { id: 17, image: chn2, name: "Arte" },
    { id: 18, image: chn18, name: "MBC Group" },
  ];

  const renderPoster = (item) => (
    <div className="group relative w-[150px] sm:w-[180px] md:w-[200px] lg:w-[220px] aspect-[2/3] rounded-card-md shadow-sm overflow-hidden border border-line">
      <img
        src={item.image}
        alt={item.name}
        loading="lazy"
        className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
      />
      <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent"></div>
    </div>
  );

  return (
    <section className="section2" id="films" style={{backgroundColor: 'var(--bg-color)'}}>
      <div className="main-content">
        <Reveal className="mb-10">
          <SectionHeading eyebrow={c.eyebrow} title={c.title} align="center" />
        </Reveal>

        {/* Carousel des films — défilement continu */}
        <Reveal delay={100} className="mb-8">
          <p className="text-xs font-bold uppercase tracking-widest text-ink-muted mb-3">{c.filmsLabel}</p>
          <Marquee
            items={films}
            duration={48}
            renderItem={renderPoster}
          />
        </Reveal>

        {/* Carousel des séries — défilement continu */}
        <Reveal delay={125} className="mb-10">
          <p className="text-xs font-bold uppercase tracking-widest text-ink-muted mb-3">{c.seriesLabel}</p>
          <Marquee
            items={series}
            direction="right"
            duration={46}
            renderItem={renderPoster}
          />
        </Reveal>

        {/* Chaînes disponibles — défilement continu */}
        <Reveal delay={150} className="mb-8">
          <Marquee
            items={channels}
            direction="right"
            duration={38}
            renderItem={(channel) => (
              <div className="bg-white rounded-card-md border border-line px-6 py-4 shadow-sm w-40 sm:w-44 flex items-center justify-center h-16 md:h-20">
                <img
                  src={channel.image}
                  alt={channel.name}
                  loading="lazy"
                  className="max-w-full max-h-full object-contain opacity-90"
                />
              </div>
            )}
          />
        </Reveal>
      </div>
    </section>
  );
}
